module.exports = __webpack_public_path__ + "fonts/7e55a84fa933e63da2fd93308d64d7fe.woff2";